import type { ApiEndpointBuilder } from "../apiEndpointHelpers";

import type {
  EmailAuthoringRequest,
  EmailAuthoringResponse,
  EmailTemplateVideoRequest,
  EmailTemplateVideoRequestResponse,
} from "@/types/adminV2/messagingEmailAuthoring";

/** Authoring preview and request-only video submission never save a template or send email. */
export const buildAdminV2MessagingEmailAuthoringEndpoints = (
  builder: ApiEndpointBuilder,
) => ({
  createAdminV2MessagingTemplateVideoRequest: builder.mutation<
    EmailTemplateVideoRequestResponse,
    EmailTemplateVideoRequest
  >({
    query: (body) => ({
      url: "/admin/v2/messaging/email-authoring/video-requests",
      method: "POST",
      data: body,
    }),
  }),
  previewAdminV2MessagingEmailAuthoring: builder.mutation<
    EmailAuthoringResponse,
    EmailAuthoringRequest
  >({
    query: (body) => ({
      url: "/admin/v2/messaging/email-authoring/preview",
      method: "POST",
      data: body,
    }),
  }),
});
